export default {"src":"/_next/static/media/trulia.b435472d.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};